import type { Chat } from '@/layer';
import type { Dialog } from '@/lib/appManagers/appMessagesManager';
import type { User } from '@/lib/appManagers/appUsersManager';
import type { MessagesPersistedRecord } from '@/lib/storages/messagesPersistent';
import { AccountDatabase, getDatabaseState, getOldDatabaseState } from '@/config/databases/state';
import AppStorage from '@/lib/storage';
import { ActiveAccountNumber } from '@/lib/accounts/types';

export type StoragesStorages = {
  users: AppStorage<Record<UserId, User>, AccountDatabase>,
  chats: AppStorage<Record<ChatId, Chat>, AccountDatabase>,
  dialogs: AppStorage<Record<PeerId, Dialog>, AccountDatabase>,
  messages: AppStorage<Record<PeerId, MessagesPersistedRecord>, AccountDatabase>
};

export default function createStorages(accountNumber: ActiveAccountNumber) {
  const names: (keyof StoragesStorages)[] = ['users', 'chats', 'dialogs', 'messages'];
  const storages: StoragesStorages = {} as any;
  for (const name of names) {
    // @ts-ignore
    storages[name] = new AppStorage(accountNumber === undefined ? getOldDatabaseState() : getDatabaseState(accountNumber), name);
  }

  return storages;
}
